// src/components/Tooltip.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Tooltip = () => {
  const [isOpen, setIsOpen] = useState(false);

  const content = {
    title: "La lógica detrás de la fantasía",
    text1: "Este sitio es mi sandbox personal, donde fusiono caos creativo y precisión técnica. El portal simboliza la entrada a soluciones a medida, pero también a mi historia: ese soy yo con mi perro de chico, camino a 'Los Álamos', la casa de campo de mi infancia. Este paisaje representa el crecimiento orgánico (SEO) que sostiene cada proyecto.",
    text2: "Aquellos días en el campo me enseñaron que lo que se siembra con paciencia crece con fuerza. Hoy, traslado esa filosofía al código: transformo visiones abstractas en experiencias digitales tangibles. 'Living dreams' no es solo un eslogan, es mi compromiso de cruzar con vos ese portal, llevando tus ideas desde la imaginación hasta una realidad digital sólida."
  };

  return (
    <div className="fixed-tooltip-container">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, x: -20 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.8, x: -20 }}
            className="tooltip-box"
          >
            <h3>{content.title}</h3>
            <p>{content.text1}</p>
            <p className="mt-paragraph">{content.text2}</p>
            <div className="tooltip-tech">
              <span>#ReactJS</span>
              <span>#SEO</span>
              <span>#LivingDreams</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        className="tooltip-trigger"
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        // Animación de resplandor con el nuevo color #dd2a6b
        animate={{
          boxShadow: [
            "0 0 5px #dd2a6b",
            "0 0 20px #dd2a6b",
            "0 0 5px #dd2a6b",
          ],
        }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
        {isOpen ? "×" : "?"}
      </motion.button>

      <style jsx>{`
        .fixed-tooltip-container {
          position: fixed;
          bottom: 25px;
          left: 25px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .tooltip-trigger {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(221, 42, 107, 0.2); /* #dd2a6b con opacidad */
          border: 2px solid #dd2a6b;
          color: white;
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(5px);
          outline: none;
        }

        .tooltip-box {
          background: rgba(10, 10, 10, 0.95);
          border: 1px solid rgba(221, 42, 107, 0.5); /* Borde en la gama #dd2a6b */
          backdrop-filter: blur(15px);
          padding: 22px;
          border-radius: 12px;
          width: 320px;
          margin-bottom: 15px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.7);
          color: #e0e0e0;
        }

        .tooltip-box h3 {
          margin: 0 0 12px 0;
          font-size: 15px;
          color: #dd2a6b; /* Título principal en #dd2a6b */
          text-transform: uppercase;
          letter-spacing: 1.5px;
          font-weight: 800;
        }

        .tooltip-box p {
          font-size: 12.5px;
          line-height: 1.6;
          margin: 0;
          opacity: 0.9;
        }

        .mt-paragraph {
          margin-top: 12px !important;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 12px;
        }

        .tooltip-tech {
          margin-top: 18px;
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .tooltip-tech span {
          font-size: 10px;
          background: rgba(221, 42, 107, 0.15); /* Fondo suave de los tags */
          padding: 3px 8px;
          border-radius: 4px;
          color: #ffca28; /* Mantenemos el amarillo para el contraste con los tags */
          border: 1px solid rgba(255, 202, 40, 0.2);
        }
      `}</style>
    </div>
  );
};

export default Tooltip;